module.exports = __webpack_public_path__ + "img/Myfacebook.1d8649ad.svg";